import "./Sidebar.scss";

import React, { useEffect } from "react";

import { createPortal } from "react-dom";

/**
 * A responsive sidebar component for React
 */

const Sidebar = (props) => {
  const onClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    props.onClose && props.onClose(props.position);
  };

  useEffect(() => {
    if (!props.collapsed) {
      //hvis den går fra collapsed til open
      props.onOpen();
    }
  }, [props.collapsed]);

  // Override render() so the <Map> element contains a div we can render to

  const position = " sidebar-" + (props.position || "left");
  const collapsed = props.collapsed ? " collapsed" : "";

  return createPortal(
    <div
      id={props.id}
      className={"sidebar leaflet-touch" + position + collapsed}
    >
      <div className="sidebarInner">
        <div className="close" onClick={onClose}>
          ×
        </div>
        {props.children}
      </div>
    </div>,
    document.getElementById("sidebar-container") || document.body
  );
};

export default Sidebar;
